module.exports = __webpack_public_path__ + "static/img/img-common-placeholder.f0a9e23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/img-common-placeholder.png
// module id = Ljmi
// module chunks = 1